import { Endereco } from 'app/types/Endereco';
import React, { useMemo } from 'react';
import { IColuna } from "../../../types/IColuna";
import Legenda from "../../itens-orcamento/legenda/Legenda";
import * as R from 'ramda';
import filter from "lodash/filter";
import indexOf from "lodash/indexOf";
import sortBy from "lodash/sortBy";
import { AcoesHeadEnderecoOrcamento } from "./table-head/AcoesHeadEnderecosOrcamento";
import { Obra } from "app/types/Obra";

const estiloTabela = require('../../../estilos/tabelas.module.scss').default
import { fonteGradeOuHerdada } from 'app/utils/tamanhoFonteGrid'

export type GridEnderecosOrcamentoProps = {
    enderecos: Endereco[];
    onToggleColunaSelecionada: (nomeColuna: string, selecionada: boolean) => void
    onToggleSelecionarTodasColunas: (selecionar: boolean) => void;
    onAlterarFonte: (fonte: number) => void
    obras: Obra[]
    obraSelecionada?: number
    handleChange: (obraId: Obra) => void
    tamanhoFonte: number
    colunas: IColuna[]
    permitirVisualizarFaturamento: boolean,
    somenteLeitura: boolean
    orcamentoTransferencia: boolean,
    permiteEngrenagemGrid?: boolean; // 418506
    onAlterarEnderecoEntrega: (codigo: number, selecionado: boolean) => void
    onAlterarEnderecoCobranca: (codigo: number, selecionado: boolean) => void
    onAlterarEnderecoFaturamento: (codigo: number, selecionado: boolean) => void
}


export const GridEnderecosOrcamento = (props: GridEnderecosOrcamentoProps) => {

    const itensEnderecosOrcamento = ({ nomeColuna, item }: {
        nomeColuna: string, item: Endereco
    }) => {

        const fn = R.cond([
            [R.equals("Entrega"), _ => <td key={`GridEnderecosOrcamento_Entrega_${item.Codigo}`} style={{textAlign: 'center'}}>
                <input type="checkbox"
                    id={`GridEnderecosOrcamento_Entrega_${item.Codigo}`}
                    disabled={!item.PermitirEntrega || props.somenteLeitura}
                    checked={item.Entrega}
                    onChange={(e) => props.onAlterarEnderecoEntrega(item.Codigo, e.target.checked)} /></td>],
            [R.equals("Cobrança"), _ => <React.Fragment key={`GridEnderecosOrcamento_Cobrança_${item.Codigo}`}>{!props.orcamentoTransferencia && <td style={{textAlign: 'center'}}>
                <input type="checkbox"
                    id={`GridEnderecosOrcamento_Cobrança_${item.Codigo}`}
                    disabled={!item.PermitirCobranca || props.somenteLeitura}
                    checked={item.Cobranca}
                    onChange={(e) => props.onAlterarEnderecoCobranca(item.Codigo, e.target.checked)} />
                </td>}</React.Fragment>],
            [R.equals("Faturamento"), _ => <React.Fragment key={`GridEnderecosOrcamento_Faturamento_${item.Codigo}`}>{!props.orcamentoTransferencia && props.permitirVisualizarFaturamento && <td style={{textAlign: 'center' }}>
                <input type="checkbox"
                    id={`GridEnderecosOrcamento_Faturamento_${item.Codigo}`}
                    disabled={!item.PermitirFaturamento || props.somenteLeitura}
                    checked={item.Faturamento}
                    onChange={(e) => props.onAlterarEnderecoFaturamento(item.Codigo, e.target.checked)} /></td>}</React.Fragment>],
            [R.equals("Endereço"), _ => <td style={{ boxShadow: 'inset 4px 0px ' + item.Cor }}
                        id={`GridEnderecosOrcamento_Endereço_${item.Codigo}`}
                        key={`GridEnderecosOrcamento_Endereço_${item.Codigo}`}
                    >{item.Logradouro}</td>],
            [R.equals("Número"), _ => <td
                      id={`GridEnderecosOrcamento_Numero_${item.Codigo}`}
                      key={`GridEnderecosOrcamento_Numero_${item.Codigo}`}
                    >{item.Numero}</td>],
            [R.equals("Complemento"), _ => <td
                    id={`GridEnderecosOrcamento_Compl_${item.Codigo}`}
                    key={`GridEnderecosOrcamento_Compl_${item.Codigo}`}
                >{item.Complemento}</td>],
            [R.equals("Bairro"), _ => <td
                        id={`GridEnderecosOrcamento_Bairro_${item.Codigo}`}
                        key={`GridEnderecosOrcamento_Bairro_${item.Codigo}`}
                    >
                    {item.Bairro}</td>],
            [R.equals("Cidade"), _ => <td
                        id={`GridEnderecosOrcamento_Cidade_${item.Codigo}`}
                        key={`GridEnderecosOrcamento_Cidade_${item.Codigo}`}
                    >
                {item.NomeCidade}</td>],
            [R.equals("UF"), _ => <td
                        id={`GridEnderecosOrcamento_UF_${item.Codigo}`}
                        key={`GridEnderecosOrcamento_UF_${item.Codigo}`}
                    >{item.SiglaUf}</td>],
            [R.equals("CEP"), _ => <td
                        id={`GridEnderecosOrcamento_Cep_${item.Codigo}`}
                        key={`GridEnderecosOrcamento_Cep_${item.Codigo}`}
                    >
                    {item.Cep}</td>],
            [R.equals("Refêrencia"), _ => <td
                        id={`GridEnderecosOrcamento_Referencia_${item.Codigo}`}
                        key={`GridEnderecosOrcamento_Referencia_${item.Codigo}`}
                    >
                        {item.Referencia}</td>], // sim, esta escrito errado, rs
            [R.equals("Tipo"), _ => <React.Fragment key={`GridEnderecosOrcamento_Tipo_${item.Codigo}`}>{!props.orcamentoTransferencia && <td
                        id={`GridEnderecosOrcamento_Tipo_${item.Codigo}`}
                    >
                    {item.Tipo}</td>}</React.Fragment>]
        ])

        return fn(nomeColuna)
    }

    let ordenacao = [
        "Entrega",
        "Cobrança",
        "Faturamento",
        "Endereço",
        "Número",
        "Complemento",
        "Bairro",
        "Cidade",
        "UF",
        "CEP",
        "Refêrencia", // sim, esta escrito errado, rs
        "Tipo"
    ]

    let colunasOrdenadas = filter(props.colunas, (coluna) => ordenacao.includes(coluna.Nome))
    sortBy(props.colunas, (coluna) => indexOf(ordenacao, coluna.Nome))

    const traduzirNomeColuna = (nomeColuna: string) => {
        const nomeParaCabecalhoMap = {
            "Entrega": "Ent.",
            "Cobrança": "Cob.",
            "Faturamento": "Fat.",
            "CEP": "Cep",
            "Refêrencia": "Referência" // sim, esta escrito errado, rs
        }

        return nomeColuna in nomeParaCabecalhoMap ? nomeParaCabecalhoMap[nomeColuna] : nomeColuna
    }

    const cabecalhoColunaEnderecosOrcamento = ({ nomeColuna }: { nomeColuna: string }) => {
        var usarColuna = (props.colunas ?? []).find(c => c.Nome == nomeColuna)?.Selecionada ?? false;
        if (usarColuna && props.orcamentoTransferencia && (nomeColuna == "Cobrança" || nomeColuna == "Faturamento" || nomeColuna == "Tipo")) {
            usarColuna = false;
        }
        if (usarColuna && (!props.permitirVisualizarFaturamento && nomeColuna == "Faturamento")) {
            usarColuna = false;
        }
        if (nomeColuna == "Cobrança" || nomeColuna == "Faturamento" || nomeColuna == "Entrega" ){
            return usarColuna ? <th key={`GridEnderecosOrcamento_Cabeçalho_${nomeColuna}`}>{traduzirNomeColuna(nomeColuna)}</th> : <React.Fragment key={`GridEnderecosOrcamento_Cabeçalho_${nomeColuna}`} />;
        }
        return usarColuna ? <th className={estiloTabela.cabecalhoTexto}
                id={`GridEnderecosOrcamento_Cabeçalho_${nomeColuna}`}
                key={`GridEnderecosOrcamento_Cabeçalho_${nomeColuna}`}
        >{traduzirNomeColuna(nomeColuna)}</th> : <React.Fragment key={`GridEnderecosOrcamento_Cabeçalho_${nomeColuna}`} />;
    }

    const tabelaEnderecosOrcamento = <>
        <div className={estiloTabela.containerRolavel}>

            <AcoesHeadEnderecoOrcamento
                onToggleColunaSelecionada={props.onToggleColunaSelecionada}
                onAlterarFonte={props.onAlterarFonte}
                tamanhoFonte={props.tamanhoFonte}
                colunas={colunasOrdenadas}
                onToggleSelecionarTodasColunas={props.onToggleSelecionarTodasColunas}
                permiteEngrenagemGrid={props.permiteEngrenagemGrid ?? false} // 418506
            />

            <table id="grid-enderecos-orcamento" className={`_table _w-full _border-collapse ${estiloTabela.tabela}`}>
                <thead>
                    <tr
                        id={`GridEnderecosOrcamento_LinhaCabeçalho`}
                        key={`GridEnderecosOrcamento_LinhaCabeçalho`} 
                    >
                        {(colunasOrdenadas ?? []).filter(c => c.Selecionada)?.map(coluna => cabecalhoColunaEnderecosOrcamento({
                            nomeColuna: coluna.Nome
                        }))}
                    </tr>
                </thead>
                <tbody style={{ fontSize: fonteGradeOuHerdada(props.tamanhoFonte) }}
                        id={`GridEnderecosOrcamento_tBody`}
                        key={`GridEnderecosOrcamento_tBody`} 
                >
                    {
                        props.enderecos?.map((item) => (
                            <tr key={item.Codigo.toString()}
                                id={`GridEnderecosOrcamento_Linha+${item.Codigo}`}
                            >
                                {colunasOrdenadas?.filter(c => c.Selecionada)?.map(coluna => (
                                    itensEnderecosOrcamento({
                                        nomeColuna: coluna.Nome,
                                        item: item
                                    }))
                                )}
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        </div>
    </>

const legenda = useMemo(() => (
    <Legenda itens={[
        { nome: "Todos", cor: "#C0C0C0" },
        { nome: "Faturamento / Entrega", cor: "#FF8000" },
        { nome: "Cobrança / Entrega", cor: "#000000" },
        { nome: "Faturamento / Cobrança", cor: "#800000" },
        { nome: "Entrega", cor: "#FF0000" },
        { nome: "Cobrança", cor: "var(--mu-azul-marcador, #0000FF)" },
        { nome: "Faturamento", cor: "#00FF00" },
    ]} />
), []);

const relacionaObraEndereco = useMemo(() => (
    <section style={{ marginBottom: "8px" }}>
        <span style={{ marginRight: "4px", marginTop: "4px" }}
            id={`GridEnderecosOrcamento_Obra`}
            key={`GridEnderecosOrcamento_Obra`} 
        
        >Obra</span>
        <select
            title="Ao selecionar a obra o endereço será automaticamente alterado e vice-versa"
            value={(props.obraSelecionada) ?? ""}
            disabled={props.somenteLeitura}
            onChange={(e) => props.handleChange(props.obras.find(o => o?.IdObra === Number(e.target.value)))}
            id={`GridEnderecosOrcamento_Obra_Select`}
            key={`GridEnderecosOrcamento_Obra_Select`} 
        >
            <option value={0}>Nenhuma</option>
            {props.obras.map((item) => (
                <option key={item?.IdObra} value={item?.IdObra}>{item.Apelido}</option>
            ))}
        </select>
    </section>
), [props.obraSelecionada, props.obras, props.somenteLeitura, props.handleChange]);

    return <>
        {tabelaEnderecosOrcamento}
        {relacionaObraEndereco} 
        {legenda}
        {<section style={{ marginBottom: "100px" }} />}
    </>
}
